exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".report-list-more[data-v-4360f27e]{color:#346f8b;font-weight:600;white-space:nowrap}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/ScheduledReports/ReportListCell.vue"],"names":[],"mappings":"AACA,mCACI,cAAe,AACf,gBAAiB,AACjB,kBAAoB,CACvB","file":"ReportListCell.vue","sourcesContent":["\n.report-list-more[data-v-4360f27e] {\n    color: #346F8B;\n    font-weight: 600;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4360f27e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ScheduledReports/ReportListCell.vue
// module id = 2394
// module chunks = 22